import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS, IMAGES } from "@/lib/content";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="manifesto" ref={ref} data-testid="manifesto" className="bg-[#1A1A1A] text-[#FBF9F6] py-24 md:py-40">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="eyebrow">02 — The atelier</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl tracking-tight mt-4 max-w-4xl leading-[1.02]">
            A quiet obsession with how things are joined.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mt-20">
          <div className="lg:col-span-7 order-2 lg:order-1">
            {CHAPTERS.map((ch, i) => (
              <Reveal key={ch.n} delay={i * 0.05}>
                <div className="border-t border-[#3a3a3a] py-10 md:py-12 grid grid-cols-1 md:grid-cols-[100px_1fr] gap-6">
                  <span className="font-serif text-4xl md:text-5xl text-[#8C7A6B]">{ch.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl tracking-tight mb-3">{ch.title}</h3>
                    <p className="text-[#B8B4AE] leading-relaxed max-w-xl">{ch.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative overflow-hidden aspect-[3/4] sticky top-28">
              <motion.img style={{ y }} src={IMAGES.craft1} alt="Maker at the bench" className="img-cover scale-110" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
